<template>
  <div
      class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 text-slate-100 p-6"
      dir="rtl"
  >
    <div class="max-w-7xl mx-auto space-y-5">
      <!-- Header -->
      <div class="rounded-3xl border border-white/10 bg-slate-900/80 p-5 shadow-2xl">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 class="text-sm font-bold text-slate-50">
              مدیریت درخواست‌های خروج دستی موجودی
            </h1>
          </div>

          <button
              @click="refreshAll"
              :disabled="loading.list"
              class="px-4 py-2 rounded-xl bg-amber-400 text-slate-950 text-sm font-bold disabled:opacity-50"
          >
            {{ loading.list ? 'در حال دریافت...' : 'بروزرسانی' }}
          </button>
        </div>
      </div>

      <!-- Notice -->
      <transition name="fade">
        <div
            v-if="notice"
            class="rounded-2xl border border-emerald-400/40 bg-emerald-500/10 px-5 py-4 text-emerald-100 text-sm"
        >
          {{ notice }}
        </div>
      </transition>

      <!-- Filters -->
      <div v-if="false" class="rounded-3xl border border-white/10 bg-slate-900/80 p-4 shadow-2xl">
        <div class="grid grid-cols-1 md:grid-cols-6 gap-3">
          <div class="md:col-span-2">
            <label class="block text-xs text-slate-400 mb-2">جستجو</label>
            <input
                v-model="filters.search"
                @keyup.enter="applyFilters"
                type="text"
                class="w-full rounded-2xl bg-slate-950 border border-white/10 px-4 py-3 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60"
                placeholder="شماره درخواست، نام کالا، توضیحات..."
            />
          </div>

          <div>
            <label class="block text-xs text-slate-400 mb-2">پارتنر</label>
            <select
                v-model="filters.partner"
                class="w-full rounded-2xl bg-slate-950 border border-white/10 px-3 py-3 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60"
            >
              <option value="">همه پارتنرها</option>
              <option
                  v-for="p in partners"
                  :key="p.id"
                  :value="p.id"
              >
                {{ p.name || p.title || p.full_name || `Partner #${p.id}` }}
              </option>
            </select>
          </div>

          <div>
            <label class="block text-xs text-slate-400 mb-2">وضعیت</label>
            <select
                v-model="filters.status"
                class="w-full rounded-2xl bg-slate-950 border border-white/10 px-3 py-3 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60"
            >
              <option value="">همه</option>
              <option value="draft">در انتظار تأیید</option>
              <option value="confirmed">تأیید شده</option>
              <option value="cancelled">لغو شده</option>
            </select>
          </div>

          <div>
            <label class="block text-xs text-slate-400 mb-2">از تاریخ</label>
            <input
                v-model="filters.date_from"
                type="date"
                class="w-full rounded-2xl bg-slate-950 border border-white/10 px-3 py-3 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60"
            />
          </div>

          <div>
            <label class="block text-xs text-slate-400 mb-2">تا تاریخ</label>
            <input
                v-model="filters.date_to"
                type="date"
                class="w-full rounded-2xl bg-slate-950 border border-white/10 px-3 py-3 text-sm text-slate-100 focus:outline-none focus:border-amber-400/60"
            />
          </div>
        </div>

        <div class="flex flex-wrap gap-3 mt-4">
          <button
              @click="applyFilters"
              class="px-5 py-2.5 rounded-xl bg-gradient-to-r from-amber-400 to-pink-500 text-slate-950 text-sm font-bold"
          >
            اعمال فیلتر
          </button>

          <button
              @click="clearFilters"
              class="px-5 py-2.5 rounded-xl bg-slate-800 text-slate-200 border border-white/10 text-sm"
          >
            حذف فیلتر
          </button>
        </div>
      </div>

      <!-- Summary -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div class="rounded-md border border-white/10 bg-slate-900/80 p-4">
          <div class="text-xs text-slate-400">

            کل درخواست‌ها
            <span class="text-md font-black text-slate-50 mr-2">{{ exits.total }}</span>
          </div>

        </div>

        <div class="rounded-md border border-amber-400/20 bg-amber-500/10 p-4">
          <div class="text-sm text-amber-200">در انتظار تأیید
            <span class="text-md font-black text-amber-300 mr-2">{{ summary.pending }}</span>
          </div>
        </div>

        <div class="rounded-md border border-emerald-400/20 bg-emerald-500/10 p-4">
          <div class="text-sm text-emerald-200">تأیید شده
            <span class="text-mdfont-black text-emerald-300 mr-2">{{ summary.confirmed }}</span>

          </div>
        </div>

        <div class="rounded-md border border-rose-400/20 bg-rose-500/10 p-4">
          <div class="text-sm text-rose-200">
            لغو شده
            <span class="text-md font-black text-rose-300 mr-2">{{ summary.cancelled }}</span>

          </div>
        </div>
      </div>

      <!-- List -->
      <div class="rounded-3xl border border-white/10 bg-slate-900/80 overflow-hidden shadow-2xl">
        <div class="px-5 py-4 border-b border-white/10 flex items-center justify-between">
          <div class="text-sm text-slate-400">
            نمایش
            <span class="text-amber-300 font-bold">{{ exits.items.length }}</span>
            از
            <span class="text-emerald-300 font-bold">{{ exits.total }}</span>
          </div>
        </div>

        <div class="overflow-auto">
          <table class="w-full text-sm">
            <thead class="bg-slate-950 text-slate-300 sticky top-0">
            <tr>
              <th class="px-4 py-3 text-center">شناسه</th>
              <th class="px-4 py-3 text-center">پارتنر</th>
              <th class="px-4 py-3 text-center">ثبت‌کننده</th>
              <th class="px-4 py-3 text-center">تاریخ</th>
              <th class="px-4 py-3 text-center">تعداد ردیف</th>
              <th class="px-4 py-3 text-center">جمع تعداد</th>
              <th class="px-4 py-3 text-center">وضعیت</th>
              <th class="px-4 py-3 text-center">عملیات</th>
            </tr>
            </thead>

            <tbody class="divide-y divide-white/5">
            <tr
                v-for="x in exits.items"
                :key="x.id"
                class="hover:bg-slate-800/40 transition"
            >
              <td class="px-4 py-3 text-center text-cyan-300 font-bold">
                #{{ x.id }}
              </td>

              <td class="px-4 py-3 text-center">
                {{ partnerDisplay(x) }}
              </td>

              <td class="px-4 py-3 text-center text-slate-300">
                {{ x.created_by_name || x.created_by || '---' }}
              </td>

              <td class="px-4 py-3 text-center text-slate-300 whitespace-nowrap">
                {{ x.exit_date || x.created_at || '---' }}
              </td>

              <td class="px-4 py-3 text-center">
                {{ (x.items || []).length }}
              </td>

              <td class="px-4 py-3 text-center text-emerald-300 font-bold">
                {{ x.total_quantity || calcExitTotal(x) }}
              </td>

              <td class="px-4 py-3 text-center">
                  <span
                      class="px-2 py-1 rounded-lg border text-xs"
                      :class="statusClass(x.status)"
                  >
                    {{ statusLabel(x.status) }}
                  </span>
              </td>

              <td class="px-4 py-3 text-center">
                <div class="flex flex-wrap justify-center gap-2">
                  <button
                      @click="openDetails(x)"
                      class="px-3 py-2 rounded-xl bg-slate-800 border border-white/10 text-xs text-slate-200 hover:bg-slate-700"
                  >
                    جزئیات
                  </button>
                  <button
                      @click="printExit(x)"
                      class="px-3 py-2 rounded-xl bg-cyan-500/15 border border-cyan-400/30 text-cyan-200 text-xs hover:bg-cyan-500/25"
                  >
                    چاپ
                  </button>

                  <button
                      v-if="canConfirm(x)"
                      @click="openConfirmModal(x, 'confirm')"
                      :disabled="loading.action"
                      class="px-3 py-2 rounded-xl bg-emerald-500/20 border border-emerald-400/30 text-emerald-200 text-xs hover:bg-emerald-500/30 disabled:opacity-50"
                  >
                    تأیید
                  </button>

                  <button
                      v-if="canCancel(x)"
                      @click="openConfirmModal(x, 'cancel')"
                      :disabled="loading.action"
                      class="px-3 py-2 rounded-xl bg-rose-500/20 border border-rose-400/30 text-rose-200 text-xs hover:bg-rose-500/30 disabled:opacity-50"
                  >
                    لغو
                  </button>
                </div>
              </td>
            </tr>

            <tr v-if="!exits.items.length && !loading.list">
              <td colspan="8" class="px-6 py-16 text-center text-slate-500">
                درخواستی پیدا نشد.
              </td>
            </tr>

            <tr v-if="loading.list">
              <td colspan="8" class="px-6 py-16 text-center text-slate-400">
                در حال دریافت اطلاعات...
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="px-5 py-4 border-t border-white/10 bg-slate-950 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div class="text-sm text-slate-400">
            صفحه
            <span class="text-amber-300 font-bold">{{ exits.page }}</span>
            از
            <span class="text-emerald-300 font-bold">{{ exits.total_pages }}</span>
          </div>

          <div class="flex items-center gap-2">
            <select
                v-model.number="exits.page_size"
                @change="goPage(1)"
                class="rounded-xl bg-slate-900 border border-white/10 px-3 py-2 text-sm"
            >
              <option :value="10">10 مورد</option>
              <option :value="25">25 مورد</option>
              <option :value="50">50 مورد</option>
            </select>

            <button
                @click="goPage(exits.page - 1)"
                :disabled="exits.page <= 1"
                class="px-4 py-2 rounded-xl bg-slate-800 border border-white/10 text-sm disabled:opacity-50"
            >
              قبلی
            </button>

            <button
                @click="goPage(exits.page + 1)"
                :disabled="exits.page >= exits.total_pages"
                class="px-4 py-2 rounded-xl bg-slate-800 border border-white/10 text-sm disabled:opacity-50"
            >
              بعدی
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Details Modal -->
    <transition name="fade">
      <div
          v-if="detailsModal.visible"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-md p-4"
          @click.self="closeDetails"
      >
        <div class="w-full max-w-3xl rounded-3xl bg-slate-950 border border-white/10 overflow-hidden shadow-2xl">
          <div class="p-5 border-b border-white/10 flex items-start justify-between gap-4">
            <div>
              <h3 class="font-bold text-slate-50">
                جزئیات درخواست خروج #{{ detailsModal.item.id }}
              </h3>
              <p class="text-xs text-slate-400 mt-2">
                پارتنر:
                <span class="text-amber-300">{{ partnerDisplay(detailsModal.item) }}</span>
                |
                وضعیت:
                <span :class="statusTextClass(detailsModal.item.status)">
                  {{ statusLabel(detailsModal.item.status) }}
                </span>
              </p>
              <p class="text-xs text-slate-500 mt-2">
                {{ detailsModal.item.description || 'بدون توضیح' }}
              </p>
            </div>

            <button @click="closeDetails" class="text-slate-400 hover:text-white">
              ✕
            </button>
          </div>

          <div class="p-5 max-h-[65vh] overflow-auto">
            <table class="w-full text-sm">
              <thead class="text-slate-400 border-b border-white/10">
              <tr>
                <th class="py-3 text-right">کالا</th>
                <th class="py-3 text-center">شناسه محصول</th>
                <th class="py-3 text-center">تعداد خروج</th>
              </tr>
              </thead>

              <tbody class="divide-y divide-white/5">
              <tr
                  v-for="it in detailsModal.item.items || []"
                  :key="it.id"
              >

                <td class="x-2 py-1 align-top items-center">
                  <div class="flex gap-4 items-start">
                    <div class="flex-shrink-0">
                      <div class="w-12 h-12 rounded-2xl bg-slate-800 overflow-hidden border-2 border-white/10
                               group-hover:border-amber-400/50 transition-all duration-300">
                        <img
                            v-if="it.image"
                            :src="img_source(it.image)"
                            alt="img"
                            class="w-full h-full object-cover"
                        />
                        <div v-else
                             class="w-full h-full bg-gradient-to-br from-slate-700 to-slate-600 flex items-center justify-center">
                          <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
                          </svg>
                        </div>
                      </div>
                    </div>

                    <div class="flex flex-col min-w-0 flex-1">
                    <span class=" text-slate-50 truncate leading-tight  text-[10px]">
                      <span class="text-base font-bold text-slate-50 truncate leading-tight text-[8px]"
                            v-if="it.variation_of_name">
                      {{ it.variation_of_name }}
                        :
                      </span>

                      {{ it.product_name }}
                    </span>
                      <div class="flex items-center gap-3 mt-2">
                      <span class="text-xs text-slate-400 bg-slate-800/50 px-2 py-1 rounded-lg ">
                        {{ it.product_sixteen_digit_code || '---' }}
                      </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="py-3 text-center text-slate-400">
                  {{ it.product || it.product_id || '---' }}
                </td>
                <td class="py-3 text-center text-emerald-300 font-bold">
                  {{ it.quantity }}
                </td>
              </tr>

              <tr v-if="!(detailsModal.item.items || []).length">
                <td colspan="3" class="py-10 text-center text-slate-500">
                  آیتمی ثبت نشده است.
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <div
              v-if="canConfirm(detailsModal.item) || canCancel(detailsModal.item) || canPrint(detailsModal.item)"
              class="p-5 border-t border-white/10 bg-slate-900/70 flex justify-end gap-3"
          >
            <button
                @click="printExit(detailsModal.item)"
                class="px-4 py-2 rounded-xl bg-cyan-500/15 border border-cyan-400/30 text-cyan-200 text-sm"
            >
              چاپ رسید خروج
            </button>
            <button
                v-if="canCancel(detailsModal.item)"
                @click="openConfirmModal(detailsModal.item, 'cancel')"
                class="px-4 py-2 rounded-xl bg-rose-500/20 border border-rose-400/30 text-rose-200 text-sm"
            >
              لغو درخواست
            </button>
            <button
                v-if="canConfirm(detailsModal.item)"
                @click="openConfirmModal(detailsModal.item, 'confirm')"
                class="px-4 py-2 rounded-xl bg-emerald-500/20 border border-emerald-400/30 text-emerald-200 text-sm"
            >
              تأیید و کسر موجودی
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Confirm Action Modal -->
    <transition name="fade">
      <div
          v-if="actionModal.visible"
          class="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-md p-4"
          @click.self="closeActionModal"
      >
        <div class="w-full max-w-md rounded-3xl bg-slate-950 border border-white/10 overflow-hidden shadow-2xl">
          <div class="p-5 border-b border-white/10" :class="actionModal.type === 'confirm' ? 'bg-emerald-500/5' : 'bg-rose-500/5'">
            <div class="text-xs text-slate-400">
              تأیید عملیات
            </div>
            <h3 class="text-lg font-bold text-slate-50 mt-1">
              {{ actionModal.type === 'confirm' ? 'تأیید خروج موجودی' : 'لغو درخواست خروج' }}
            </h3>
            <p class="text-xs mt-2" :class="actionModal.type === 'confirm' ? 'text-emerald-200/80' : 'text-rose-200/80'">
              درخواست #{{ actionModal.item.id }}
            </p>
          </div>

          <div class="p-5 space-y-4">
            <div class="rounded-2xl bg-slate-900 border border-white/10 p-4 text-sm leading-7 text-slate-300">
              <template v-if="actionModal.type === 'confirm'">
                با تأیید این درخواست، موجودی کالاهای ثبت‌شده از انبار
                <span class="text-amber-300 font-bold">پردازش</span>
                کم می‌شود و برای هر آیتم سند ثبت می‌گردد.
                <br>
              </template>

              <template v-else>
                با لغو این درخواست، موجودی تغییری نمی‌کند و درخواست بسته می‌شود.
              </template>
            </div>

            <div class="flex gap-3">
              <button
                  @click="closeActionModal"
                  :disabled="loading.action"
                  class="flex-1 px-4 py-3 rounded-2xl bg-slate-800 text-slate-200 border border-white/10 text-sm disabled:opacity-50"
              >
                انصراف
              </button>

              <button
                  @click="runAction"
                  :disabled="loading.action"
                  class="flex-1 px-4 py-3 rounded-2xl text-sm font-bold disabled:opacity-50"
                  :class="actionModal.type === 'confirm'
                  ? 'bg-emerald-500 text-slate-950'
                  : 'bg-rose-500 text-white'"
              >
                {{ loading.action ? 'در حال انجام...' : actionButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'PartnerStockExitManager',

  data() {
    return {
      notice: '',
      pendingOpenExitId: null,
      hasHandledRouteOpen: false,

      loading: {
        list: false,
        partners: false,
        action: false,
      },

      partners: [],

      filters: {
        search: '',
        partner: '',
        status: '',
        date_from: '',
        date_to: '',
      },

      exits: {
        items: [],
        total: 0,
        page: 1,
        page_size: 10,
        total_pages: 1,
      },

      summary: {
        pending: 0,
        confirmed: 0,
        cancelled: 0,
      },

      detailsModal: {
        visible: false,
        item: {},
      },

      actionModal: {
        visible: false,
        type: '',
        item: {},
      },
    }
  },

  watch: {
    '$route.query.exit_id'() {
      this.hasHandledRouteOpen = false
      this.fetchExits()
    },
  },

  computed: {
    isPartnerUser() {
      return this.user && this.user.user_type === 'prtnr'
    },

    isManagerUser() {
      return this.user && this.user.user_type === 'ma'
    },

    isCashierUser() {
      return this.user && this.user.user_type === 'cshr'
    },

    canUsePage() {
      return this.isPartnerUser || this.isManagerUser || this.isCashierUser
    },

    mustSelectPartner() {
      return this.isManagerUser || this.isCashierUser
    },


    actionButtonText() {
      return this.actionModal.type === 'confirm'
          ? 'تأیید و کسر موجودی'
          : 'لغو درخواست'
    },
  },

  created() {
    this.fetchPartners()
    this.fetchExits()
  },

  mounted() {
    document.title = 'اکسونی | مدیریت خروج پارتنر'
  },

  methods: {
    printExit(x) {
      if (!x || !x.id) return

      const url = this.endpoint(
          `partner-stock/partner-stock-exits/${x.id}/print/html/?token=${this.token}`
      )

      window.open(url, '_blank')
    },

    async openExitFromRoute(currentResults) {
      const id = this.$route && this.$route.query
          ? this.$route.query.exit_id
          : null

      if (!id || this.hasHandledRouteOpen) return

      this.hasHandledRouteOpen = true

      let item = (currentResults || []).find(x => String(x.id) === String(id))

      if (!item) {
        try {
          item = await this.apiGetPos(`partner-stock-exits/${id}/`, {})
        } catch (e) {
          console.error('openExitFromRoute detail fetch error:', e)
        }
      }

      if (!item || !item.id) {
        this.toast('درخواست ثبت شد، اما برای نمایش جزئیات باید لیست را بروزرسانی کنید.')
        return
      }

      this.openDetails(item)

      this.$nextTick(() => {
        const nextQuery = { ...(this.$route.query || {}) }
        delete nextQuery.open

        this.$router.replace({
          name: this.$route.name,
          query: nextQuery,
        }).catch(() => {})
      })
    },
    getApiErrorMessage(error, fallback) {
      if (!error) return fallback

      if (typeof error === 'string') return error

      const data = error.response && error.response.data
          ? error.response.data
          : error.data

      if (data) {
        if (typeof data === 'string') return data
        if (data.detail) return data.detail
        if (data.error) return data.error

        const firstKey = Object.keys(data)[0]
        if (firstKey) {
          if (Array.isArray(data[firstKey])) return data[firstKey][0]
          return String(data[firstKey])
        }
      }

      return fallback
    },
    toast(msg) {
      this.notice = msg
      setTimeout(() => {
        this.notice = ''
      }, 3000)
    },

    cleanParams(obj) {
      const copy = { ...(obj || {}) }
      Object.keys(copy).forEach(k => {
        if (copy[k] === '' || copy[k] === null || copy[k] === undefined) {
          delete copy[k]
        }
      })
      return copy
    },

    apiGetPos(path, params) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`partner-stock/${path}`),
          method: 'get',
          params: this.cleanParams(params || {}),
          success: data => resolve(data),
          error: err => reject(err),
        })
      })
    },

    apiPostPos(path, data) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(`partner-stock/${path}`),
          method: 'post',
          data: this.cleanParams(data || {}),
          success: data => resolve(data),
          error: err => reject(err),
        })
      })
    },

    async fetchPartners() {
      this.loading.partners = true

      try {
        const data = await this.apiGetPos('partnerList', {})
        this.partners = data.results || data || []
      } catch (e) {
        console.error('fetchPartners error:', e)
        this.partners = []
      } finally {
        this.loading.partners = false
      }
    },

    async fetchExits() {
      this.loading.list = true

      try {
        const params = {
          page: this.exits.page,
          page_size: this.exits.page_size,
          search: this.filters.search,
          partner: this.filters.partner,
          status: this.filters.status,
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
        }

        const data = await this.apiGetPos('partner-stock-exits/', params)
        const results = data.results || data || []

        this.exits.items = results
        this.exits.total = data.count || results.length
        this.exits.total_pages = Math.max(
            1,
            Math.ceil(this.exits.total / this.exits.page_size)
        )

        this.calculateSummary(results)
        await this.openExitFromRoute(results)
      } catch (e) {
        console.error('fetchExits error:', e)
        this.toast('خطا در دریافت درخواست‌های خروج')
      } finally {
        this.loading.list = false
      }
    },

    calculateSummary(items) {
      const summary = {
            pending: 0,
            confirmed: 0,
            cancelled: 0,
          }

      ;(items || []).forEach(x => {
        if (this.isConfirmed(x)) summary.confirmed += 1
        else if (this.isCancelled(x)) summary.cancelled += 1
        else summary.pending += 1
      })

      this.summary = summary
    },

    refreshAll() {
      this.fetchPartners()
      this.fetchExits()
    },

    applyFilters() {
      this.exits.page = 1
      this.fetchExits()
    },

    clearFilters() {
      this.filters = {
        search: '',
        partner: '',
        status: '',
        date_from: '',
        date_to: '',
      }
      this.applyFilters()
    },

    goPage(page) {
      const next = Math.max(1, Math.min(this.exits.total_pages, page))
      this.exits.page = next
      this.fetchExits()
    },

    openDetails(x) {
      this.detailsModal = {
        visible: true,
        item: x || {},
      }
    },

    closeDetails() {
      this.detailsModal.visible = false
      this.detailsModal.item = {}
    },

    openConfirmModal(x, type) {
      this.actionModal = {
        visible: true,
        type,
        item: x || {},
      }
    },

    closeActionModal() {
      if (this.loading.action) return
      this.actionModal.visible = false
      this.actionModal.type = ''
      this.actionModal.item = {}
    },

    async runAction() {
      const x = this.actionModal.item
      const type = this.actionModal.type

      if (!x || !x.id || !type) return
      if (type === 'confirm' && !this.canConfirm(x)) {
        this.toast('شما مجاز به تأیید این درخواست نیستید.')
        return
      }

      if (type === 'cancel' && !this.canCancel(x)) {
        this.toast('شما مجاز به لغو این درخواست نیستید.')
        return
      }
      this.loading.action = true

      try {
        const path = type === 'confirm'
            ? `partner-stock-exits/${x.id}/confirm/`
            : `partner-stock-exits/${x.id}/cancel/`

        const updated = await this.apiPostPos(path, {})

        this.toast(type === 'confirm'
            ? 'درخواست خروج تأیید شد و موجودی کم شد'
            : 'درخواست خروج لغو شد'
        )

        this.actionModal.visible = false

        if (this.detailsModal.visible && this.detailsModal.item && this.detailsModal.item.id === x.id) {
          this.detailsModal.item = updated
        }

        await this.fetchExits()
      } catch (e) {
        console.error('runAction error:', e)
        this.toast(this.getApiErrorMessage(
            e,
            type === 'confirm'
                ? 'خطا در تأیید درخواست خروج'
                : 'خطا در لغو درخواست خروج'
        ))
      } finally {
        this.loading.action = false
      }
    },

    calcExitTotal(x) {
      return (x.items || []).reduce((sum, it) => {
        return sum + Number(it.quantity || 0)
      }, 0)
    },

    partnerDisplay(x) {
      return (
          x.partner_name ||
          x.partner_title ||
          x.partner_full_name ||
          x.partner_display_name ||
          x.partner ||
          '---'
      )
    },

    isDraft(x) {
      return x && ['draft', 'dr', 'pending'].includes(x.status)
    },

    isConfirmed(x) {
      return x && ['confirmed', 'cf'].includes(x.status)
    },
    currentUserId() {
      return this.user && this.user.id ? Number(this.user.id) : null
    },

    exitCreatorId(x) {
      return x && x.created_by ? Number(x.created_by) : null
    },

    createdByUserType(x) {
      return (
          x.created_by_user_type ||
          x.created_by_type ||
          x.creator_user_type ||
          x.created_by_role ||
          ''
      )
    },

    creatorIsPartner(x) {
      const t = this.createdByUserType(x)

      return ['prtnr', 'partner'].includes(t)
    },

    creatorIsManagerOrCashier(x) {
      const t = this.createdByUserType(x)

      return ['ma', 'manager', 'cshr', 'cashier'].includes(t)
    },

    isCreatedByCurrentUser(x) {
      const creatorId = this.exitCreatorId(x)
      const userId = this.currentUserId()

      return Boolean(creatorId && userId && creatorId === userId)
    },

    isOwnPartnerExit(x) {
      const userId = this.currentUserId()

      if (!x || !userId) return false

      const partnerUserId = Number(
          x.partner_user ||
          x.partner_user_id ||
          x.partner_owner_user ||
          0
      )

      if (partnerUserId) {
        return partnerUserId === userId
      }

      const userPartnerId = Number(
          this.user.partner_id ||
          this.user.partner ||
          this.user.partnerId ||
          0
      )

      const exitPartnerId = Number(
          x.partner_id ||
          x.partner ||
          0
      )

      if (userPartnerId && exitPartnerId) {
        return userPartnerId === exitPartnerId
      }

      return this.isPartnerUser && !this.isCreatedByCurrentUser(x)
    },

    canConfirm(x) {
      if (!this.isDraft(x)) return false
      if (this.isCreatedByCurrentUser(x)) return false

      if (this.creatorIsPartner(x)) {
        return this.isManagerUser || this.isCashierUser
      }

      if (this.creatorIsManagerOrCashier(x)) {
        return this.isPartnerUser && this.isOwnPartnerExit(x)
      }

      /*
       * اگر backend هنوز created_by_user_type نمی‌دهد،
       * برای جلوگیری از تأیید اشتباه، فقط این fallback امن را می‌گذاریم:
       * partner می‌تواند خروجی‌ای را که خودش نساخته تأیید کند.
       */
      return this.isPartnerUser && this.isOwnPartnerExit(x)
    },

    canCancel(x) {
      /*
       * لغو هم طبق همین قانون confirm باشد:
       * سازنده خودش لغو نکند؛ طرف مقابل workflow لغو کند.
       */
      return this.canConfirm(x)
    },

    canPrint(x) {
      return Boolean(x && x.id)
    },
    isCancelled(x) {
      return x && ['cancelled', 'ca'].includes(x.status)
    },

    statusLabel(status) {
      const map = {
        draft: 'در انتظار تأیید',
        dr: 'در انتظار تأیید',
        pending: 'در انتظار تأیید',
        confirmed: 'تأیید شده',
        cf: 'تأیید شده',
        cancelled: 'لغو شده',
        ca: 'لغو شده',
      }

      return map[status] || status || 'نامشخص'
    },

    statusClass(status) {
      if (['confirmed', 'cf'].includes(status)) {
        return 'bg-emerald-500/10 border-emerald-400/40 text-emerald-300'
      }

      if (['cancelled', 'ca'].includes(status)) {
        return 'bg-rose-500/10 border-rose-400/40 text-rose-300'
      }

      return 'bg-amber-500/10 border-amber-400/40 text-amber-200'
    },

    statusTextClass(status) {
      if (['confirmed', 'cf'].includes(status)) return 'text-emerald-300'
      if (['cancelled', 'ca'].includes(status)) return 'text-rose-300'
      return 'text-amber-300'
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>